import { v4 as uuidV4 } from "uuid";
import moment from "moment";
import request from "./request";
import { JSEncrypt } from "encryptlong";
import CryptoJS from "crypto-js";
import packageData from "../../package.json";
import socket from "./socket";
import network from "./network";
import service from "../service";
import isJSON from "is-json";
import { Base64 } from "js-base64";
import constant from "../constant";
import axios from "axios";
import main from "../main";
// import commonCanstant from "src/constant/index.js";
import config from "src/config";
import Vue from "vue";
// 防止多次点击
export const preventReClick = Vue.directive("preventReClick", {
  inserted: function(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 3000);
      }
    });
  }
});

// 上报错误
export const getlog = (params = {}) => {
  let url;
  const { store } = main.getVueMachine();
  if (isCustomer() && store.state.domain && store.state.domain.LOG_URL) {
    url = store.state.domain.LOG_URL + "/log/logger/collect";
  } else {
    url = process.env.VUE_APP_LOGURL;
  }
  console.log(url);
  return axios.post(url, {
    ...params,
    headers: {
      "Content-type": "application/json;charset=UTF-8"
    }
  });
};
/**
 * 测试socket
 */
export const testSocket = async params => {
  const resp = await service.getToken(params);
  setProp("token", resp.data.token);
  // await socket.initSocket();
  return Promise.resolve(resp.data);
};

/**
 * 设置 localStorage item
 * @param key 键
 * @param value 值
 */
export const setProp = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

/**
 * 获取 localStorage item
 * @param key 键
 */
export const getProp = key => {
  try {
    const data = localStorage.getItem(key);
    return data !== undefined ? JSON.parse(data) : undefined;
  } catch (e) {
    return undefined;
  }
};

// 判断浏览器
export const getdev = function() {
  const viewWidth = document.body.clientWidth;
  let dev = "";
  if (viewWidth > 750) {
    dev = "pc";
  } else {
    dev = "h5";
  }
  return dev;
};

/**
 * 删除 localStorage item
 * @param key 键
 */
export const delProp = key => {
  if (_.isArray(key)) {
    key.forEach(item => {
      localStorage.removeItem(item);
    });
  } else {
    localStorage.removeItem(key);
  }
};

/**
 * 日志增强工具
 */
export const log = function() {
  const logColorMap = {
    socket: {
      nameColor: "#b2313c",
      logColor: "#115f90"
    },
    request: {
      nameColor: "#227e00",
      logColor: "#1a4b1f"
    },
    response: {
      nameColor: "#0084aa",
      logColor: "#00262f"
    },
    sql: {
      nameColor: "#a48142",
      logColor: "#4b3821"
    }
  };

  let data = {
    name: "log",
    log: "",
    nameColor: "#167dec",
    timeColor: "#0c4264",
    logColor: "#336612"
  };
  if (arguments[0] && arguments[1] && typeof arguments[0] === "string") {
    data.name = arguments[0];
    data.log = arguments[1];
  } else if (arguments[0] && typeof arguments[0] === "string") {
    data.log = arguments[0];
  }

  if (logColorMap[data.name]) {
    data = {
      ...data,
      ...logColorMap[data.name]
    };
  }

  for (let i = 0; i < arguments.length; i++) {
    if (typeof arguments[i] === "object") {
      data = {
        ...data,
        ...arguments[i]
      };
    }
  }

  if (typeof data.log !== "string") {
    data.log = JSON.stringify(data.log);
  }

  const logSetting = getProp("log-setting") || {};

  if (logSetting[data.name] === false) return;
  // const time = moment().format("HH:mm:ss");
  // console.log(
  //   `%c ${time} %c ${data.name} %c ${data.log} %c`,
  //   `background:${data.timeColor} ; padding: 1px; color: #fff`,
  //   `background:${data.nameColor} ; padding: 1px; color: #fff`,
  //   `background:${data.logColor} ; padding: 1px; color: #fff`,
  //   "background:transparent"
  // );
};
String.prototype.replaceAllStr = function(f, e) {
  var reg = new RegExp(f, "g");
  return this.replace(reg, e);
};

/**
 * rsa加密
 */
export const RSAEncrypt = content => {
  const ck = decryptByDES(config.ak);
  const dk = decryptByDES(config.bk);
  const str = "null";
  // -----END PRIVATE KEY-----`;
  let jse = new JSEncrypt();
  jse.setPublicKey(ck);
  jse.setPrivateKey(dk);
  // return jse.encryptLong(content);
  // jse.setPrivateKey(privateKey);
  // content = JSON.stringify(content);

  // let encrypted =  jse.encryptLong(content);
  // console.log("rsa加密后的长度", encrypted.length);

  // const base64Encrypted = Base64.encode(encrypted);
  // console.log('base64加密后的长度', base64Encrypted.length);

  const base64Encrypted = Base64.encode(content);
  // console.log("base64加密后的长度", base64Encrypted.length);

  let encrypted = jse.encryptLong(base64Encrypted);
  let uncrypted = jse.decryptLong(encrypted);
  if (uncrypted.indexOf(str) != -1) {
    console.log("参数重复加密");
    encrypted = jse.encryptLong(base64Encrypted);
  }
  // console.log('rsa加密后的长度 ', encrypted.length);
  return encrypted;
  // return jse.encryptLong(content);
};

// rsa 解密
export const RSADncrypt = (content, PRIVATE_KEY) => {
  var Decrypt = new JSEncrypt();
  // content = decodeURIComponent(content);
  Decrypt.setPrivateKey(PRIVATE_KEY);
  content = content.replaceAllStr("-", "+").replaceAllStr("_", "/");
  var mob = content.length % 4;
  if (mob > 0) {
    content += "====".substr(mob);
  }
  var uncrypted = Decrypt.decryptLong(content);
  return uncrypted;
};
// // des解密
export const decryptByDES = pk => {
  const secretKey = constant.fk;

  var afterDecrypt = CryptoJS.DES.decrypt(
    pk,
    CryptoJS.enc.Utf8.parse(secretKey),
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  ).toString(CryptoJS.enc.Utf8);

  return afterDecrypt;
};
/**
 * 获取设备ID
 */
export const getDeviceID = () => {
  let deviceId = localStorage.getItem("deviceId");
  if (!deviceId) {
    deviceId = getUUID();
    localStorage.setItem("deviceId", deviceId);
  }
  return deviceId;
};

/**
 * 生成uuid
 */
export const getUUID = () => {
  return uuidV4().replace(/-/g, "");
};

/**
 * 获取设备类型
 */
export const getDeviceType = () => {
  // let $platform = "web";
  // const map = {
  //   win: 1,
  //   mac: 2,
  //   ios: 3,
  //   android: 4,
  //   web: 5
  // };
  // return map[$platform] !== undefined ? map[$platform] : -1;
  return 1;
};

/**
 * 获取基于服务器时间差的时间戳
 * @return {number}
 */
const getTime = () => {
  const diffTime = getProp("diffTime") || 0;
  const localTime = moment();
  localTime.subtract(diffTime, "milliseconds");
  return localTime.valueOf();
};

/**
 * 获取基于服务器时间差的moment对象
 * @return {*|moment.Moment}
 */
const getTimeMoment = () => {
  return moment(getTime(), "x");
};

/**
 * 获取项目版本号
 */
export const getVersion = (type = "version") => {
  return _.get(packageData, type, "");
};

/**
 * 生成请求头
 */
const getRequestHeader = () => {
  let returnCitySN = window.returnCitySN || {};
  return {
    appId: "sport",
    version: constant.VERSION,
    productId: sessionStorage.getItem("productId"),
    deviceType: 1,
    timestamp: Date.now(),
    token: getProp("token") || "",
    ip: returnCitySN["cip"] || ""
  };
};

/**
 * 生成游客名称
 */
const getGuestName = () => {
  const header = getRequestHeader();
  return `${header.productId}-${Date.now()}`;
};

/**
 * 解析json字符串
 */
export const parseJSON = (data = {}) => {
  if (data !== undefined && _.isString(data)) {
    try {
      data = JSON.parse(data);
    } catch (e) {
      data = {};
    }
  }
  return data;
};

/**
 * 解析多层json字符串
 */
export const parseScoketJSON = (data = {}) => {
  if (data !== undefined && _.isString(data)) {
    try {
      data = JSON.parse(data);
    } catch (e) {
      data = {};
    }
  }

  if (data.data !== undefined && _.isString(data.data)) {
    try {
      data.data = JSON.parse(data.data);
    } catch (e) {
      data.data = {};
    }
  }

  if (data.data.detail !== undefined && _.isString(data.data.detail)) {
    try {
      data.data.detail = JSON.parse(data.data.detail);
    } catch (e) {
      data.data.detail = {};
    }
  }
  return data;
};

/**
 * 解析base64
 */
export const parseBase64 = data => {
  if (data !== undefined && _.isString(data)) {
    if (!isJSON(data)) {
      data = Base64.decode(data);
    }
    return parseJSON(data);
  } else {
    return data;
  }
};

/**
 * 判断是否为客户端项目
 * @return {boolean}
 */
export const isCustomer = () => {
  return process.env.VUE_APP_PROJECT === "customer";
};

export const getSendFlag = () => {
  return !isCustomer();
};

/**
 * 指令转消息内容
 */
export const commandMessageFormat = message => {
  const { type, commandType } = message;
  // const {  commandType } = message;
  const formatContentCommandTypes = [
    constant.COMMAND_TYPE.CT_WELCOME_MSG, // 欢迎语 ： 8
    constant.COMMAND_TYPE.CT_END_MSG // 结束语  ： 9
  ];

  if (isCustomer()) {
    if (formatContentCommandTypes.includes(commandType)) {
      message.type = constant.MESSAGE_TYPE.MT_TEXT;
    }

    // if (commandType == constant.COMMAND_TYPE.CT_MATCH) {
    //   message.content = `客户${_.get(message, "userName", "")}与客服${_.get(
    //     message,
    //     "serverAlias",
    //     ""
    //   )}创建会话`;
    // }
  } else {
    console.log(message.content);
    // console.log(type, constant.MESSAGE_TYPE.MT_COMMAND);
    if (type == constant.MESSAGE_TYPE.MT_COMMAND) {
      if (!message.content) {
        message.content = _.get(
          constant,
          `COMMAND_TYPE_CONTENT[${commandType}]`,
          `${commandType}`
        );
      }
    }
    // if (commandType == constant.COMMAND_TYPE.CT_MATCH) {
    //   message.content = `与客户${_.get(message, "userName", "")}创建会话`;
    // }
  }

  // if (commandType == constant.COMMAND_TYPE.CT_CLOSEMSG) {
  //   message.content = `客服已关闭会话`;
  // }

  // if (commandType == constant.COMMAND_TYPE.CT_TRANSFER) {
  //   // console.log(message);
  //   message.content = `客服${_.get(
  //     message,
  //     "transferServerAliasName"
  //   )}转接会话给客服${_.get(message, "serverAlias")}`;
  // }

  if (commandType == constant.COMMAND_TYPE.CT_KICK) {
    // console.log(message);
    message.font = JSON.parse(JSON.stringify(message.content));
    // message.content = `客服${_.get(message, "serverAlias")}已下线`;
  }
  // console.log(message);
  return message;
};

/**
 *
 * 分割数组，做分页处理
 */
export const sliceMessageFn = messages => {
  sessionStorage.setItem("messages", JSON.stringify(messages));

  let sliceMessages = [];
  if (messages.length > 10) {
    sliceMessages = messages.slice(messages.length - 8, messages.length + 1);
  }
  // console.log(sliceMessages);
  return sliceMessages;
};
// new Notification(
// "您有一条新的消息", {
// dir: "‘您有一条新的消息’",
// tag: "小姐姐，你来消息了呀",
// body: messageBody,
// renotify: true,
// silent: true,
// sticky: true
// });
export const notificationNewMessage = (message, currentChannel = {}) => {
  console.log(currentChannel);
  let title = "小姐姐，您有新消息啦！";

  let options = {
    // 通知显示内容
    body: `${currentChannel.customerName || "客户"} : ${message.content}`,
    tag: title,
    // silent: true,
    // sticky: true,
    renotify: true,
    // requireInteraction: false,
    // 通知显示的图片
    icon:
      "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1594973929182&di=5d0fbb3274d1b0ee1d4c1af986d3c79a&imgtype=0&src=http%3A%2F%2F5b0988e595225.cdn.sohucs.com%2Fq_70%2Cc_zoom%2Cw_640%2Fimages%2F20181220%2F62b88315414b49d98316169ecd9c4d28.jpeg"
  };
  if (!("Notification" in window)) {
    alert("抱歉，该浏览器不支持Notification API");
  } else {
    let permission = Notification.permission;
    // 判断用户是否允许接受通知
    if (permission === "granted") {
      // 允许通知
      new Notification(title, options);
      // console.log(notice);
    } else if (permission === "default") {
      // 继续向用户询问是否允许接受通知
      Notification.requestPermission().then(res => {
        if (res === "granted") {
          // 允许通知
          new Notification(title, options);
          // console.log(notice);
        }
      });
    } else {
      // 拒绝
      // console.log("用户拒绝了");
    }
  }
};

export const refresh = ({
  beforeRegresh = () => {},
  closeFn = () => {},
  onRefreshFn = () => {}
}) => {
  if (beforeRegresh) {
    console.log("刷新前");
    beforeRegresh();
  }
  const now = new Date().getTime();
  const leaveTime = parseInt(localStorage.getItem("leaveTime"), 10);
  const diff = now - leaveTime <= 5000;
  if (!diff) {
    console.log("关闭");
    closeFn();
  } else {
    console.log("刷新");
    onRefreshFn();
  }
};

export default {
  commandMessageFormat,
  isCustomer,
  getSendFlag,
  isMobile() {
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return flag;
    // return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
  },
  parseBase64,
  parseJSON,
  getGuestName,
  getUUID,
  getVersion,
  getTime,
  getTimeMoment,
  getDeviceType,
  getDeviceID,
  getdev,
  RSAEncrypt,
  RSADncrypt,
  decryptByDES,
  setProp,
  getProp,
  delProp,
  log,
  getlog,
  socket,
  request,
  network,
  getRequestHeader,
  testSocket,
  sliceMessageFn,
  notificationNewMessage,
  refresh,
  parseScoketJSON,
  preventReClick
};
